import { setMeta, checkRule } from '@/router/middleware'
import routerView from '@/views/notifications/routerView'


const List = () => import ('@/views/notifications/List')
// const SendNotification = () => import ('@/views/notifications/SendNotification')


export default {
    path: 'notifications',
    redirect: 'notifications',
    component: routerView,
    children: [
        {
            path: '',
            name: 'notifications',
            component: List,
            meta: {
                middleware: [setMeta, checkRule],
                labelTrans: 'notification.plural',
                rules: {
                    notification: ['read_any', 'read_group', 'read_own']
                },
            },
        },
        // {
        //     path: 'send',
        //     name: 'notifications.send',
        //     component: SendNotification,
        //     meta: {
        //         middleware: [setMeta, checkRule],
        //         labelTrans: 'notification.send',
        //         rules: {
        //             notification: ['execute_any']
        //         },
        //     },
        // }
    ]
}